<!-- 
    价格设置组件
    接受：价格设置参数form
 -->
<template>
    <div class="price-container">
        <el-form ref="form" :rules="priceSettingRules" :model="priceSettingForm" label-position="left" label-width="85px" class="price-setting-box">
            <div class="title">基本计费</div>
            <el-form-item label="基本计费规则" label-width="130px" style="margin-bottom: 12px;">
                <el-radio-group v-model="priceSettingForm.base_generic_setting">
                    <el-radio :label="0" :disabled="!isEdit">全年开启</el-radio>
                    <el-radio :label="1" :disabled="!isEdit">供冷或供热季开启</el-radio>
					<el-radio :label="2" :disabled="!isEdit">全年关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="单价"  prop="base_price" v-if="priceSettingForm.base_generic_setting != 2">
                <el-input-number v-model="priceSettingForm.base_generic_rate" controls-position="right" :min="0" :max="100" size="medium" :disabled="!isEdit">
                </el-input-number><span> 元&nbsp;/&nbsp;m<sup>2</sup>&nbsp;*&nbsp;日</span>
            </el-form-item>
            <div class="title">分时间段计费</div>
            <el-form-item label="计费类型" style="margin-bottom: 0;" prop="expense_type">
                <el-radio-group v-model="priceSettingForm.expense_type">
                    <el-radio :label="1" :disabled="!isEdit">分时段计费</el-radio>
                    <el-radio :label="0" :disabled="!isEdit">不分时段计费</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- 分时段 -->
            <div v-if="priceSettingForm.expense_type === 1">
                <el-form-item label="时段类型" style="margin-bottom: 0;">
                    <el-checkbox v-model="priceSettingForm.holiday_charged" :true-label="1" :false-label="0" :disabled="!isEdit">节假日</el-checkbox>
                    <el-checkbox v-model="priceSettingForm.weekend_charged" :true-label="1" :false-label="0" :disabled="!isEdit">休息日</el-checkbox>
                    <el-checkbox v-model="priceSettingForm.working_charged" :true-label="1" :false-label="0" :disabled="!isEdit">工作日</el-checkbox>
                </el-form-item>
                <!-- 节假日 -->
               <el-form-item label="节假日" style="margin-bottom: 12px;" prop="holidays" v-if="priceSettingForm.holiday_charged == 1">
                   <!-- <el-checkbox @change="getLegalHolidays" :disabled="!isEdit">拉取国家法定节假日</el-checkbox>
                    <div class="holiday-list-box">
                        <el-tag :key="tag" v-for="tag in priceSettingForm.holidays" :closable="isEdit" :disable-transitions="false" @close="handleHolidaysDelete(tag)">
                            {{tag}}
                        </el-tag>
                        <el-date-picker 
                            v-model="priceSettingForm.holidays" 
                            type="dates" 
                            placeholder="选择日期" 
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="small"
                            :clearable="false">
                        </el-date-picker>
                    </div> -->
                    <div style="margin-top: 24px;">
                        <el-form-item label="冷量单价" prop="holiday_cool_price">
                            <el-input-number v-model="priceSettingForm.holiday_cool_price" controls-position="right" :disabled="!isEdit" :min="0" :max="100" size="medium">
                            </el-input-number><span> 元 / KWh</span>
                        </el-form-item>
                        <el-form-item label="热量单价" prop="holiday_hot_price">
                            <el-input-number v-model="priceSettingForm.holiday_hot_price" controls-position="right" :disabled="!isEdit" :min="0" :max="100" size="medium">
                            </el-input-number><span> 元 / KWh</span>
                        </el-form-item>
                    </div>
                </el-form-item>
                <!-- 周末 -->
               <el-form-item label="周末" v-if="priceSettingForm.weekend_charged == 1">
                    <!-- <el-form-item label="时段类型">
                        <el-checkbox-group v-model="priceSettingForm.weekends">
                            <el-checkbox v-for="v in weekend" :label="v.value" :key="v.label" :disabled="!isEdit">{{v.label}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item> -->
                    <!-- <div v-if="priceSettingForm.weekends.length>0"> -->
					<div>
                        <el-form-item label="冷量单价" prop="weekend_cool_price">
                            <el-input-number v-model="priceSettingForm.weekend_cool_price" :disabled="!isEdit" controls-position="right" :min="0" :max="100" size="medium">
                            </el-input-number><span> 元 / KWh</span>
                        </el-form-item>
                        <el-form-item label="热量单价" prop="weekend_hot_price">
                            <el-input-number v-model="priceSettingForm.weekend_hot_price" :disabled="!isEdit" controls-position="right" :min="0" :max="100" size="medium">
                            </el-input-number><span> 元 / KWh</span>
                        </el-form-item>
                    </div>
                </el-form-item>
                <!-- 工作日 -->
               <el-form-item label="工作日" v-if="priceSettingForm.working_charged == 1">
                    <time-range :isEdit="isEdit" :index='1' :label="'第一时间段'" 
                    :cool_price="priceSettingForm.first_cool_price"
                    :hot_price="priceSettingForm.first_hot_price"
                    :defaultValue="firstTime" @listenTime="handleTimeRange"></time-range>
                    <time-range :isEdit="isEdit" :index='2' :label="'第二时间段'" 
                    :cool_price="priceSettingForm.second_cool_price"
                    :hot_price="priceSettingForm.second_hot_price"
                    :defaultValue="secondTime" @listenTime="handleTimeRange"></time-range>
                    <time-range :isEdit="isEdit" :index='3' :label="'第三时间段'" 
                    :cool_price="priceSettingForm.third_cool_price"
                    :hot_price="priceSettingForm.third_hot_price"
                    :defaultValue="thirdTime" @listenTime="handleTimeRange"></time-range>
                </el-form-item>
            
			</div>
            <!-- 不分时段 -->
            <div v-else style="margin-top: 12px;">
                <el-form-item label="冷量单价">
                    <el-input-number v-model="priceSettingForm.base_cool_price" :disabled="!isEdit" controls-position="right" :min="0" :max="100" size="medium">
                    </el-input-number><span> 元 / KWh</span>
                </el-form-item>
                <el-form-item label="热量单价">
                    <el-input-number v-model="priceSettingForm.base_hot_price" :disabled="!isEdit" controls-position="right" :min="0" :max="100" size="medium">
                    </el-input-number><span> 元 / KWh</span>
                </el-form-item>
            </div>
            <div class="title">计费条件设置</div>
			<el-form-item  style="margin-bottom: 0;">
				<el-radio-group v-model="priceSettingForm.is_all_refrigeration">
				    <el-radio :label="0" :disabled="!isEdit">自定义供冷</el-radio>
				    <el-radio :label="1" :disabled="!isEdit">全年供冷</el-radio>
					<el-radio :label="2" :disabled="!isEdit">全年不供冷</el-radio>
				</el-radio-group>
			</el-form-item>
            <el-form-item v-if='priceSettingForm.is_all_refrigeration === 0' label="供冷" prop="summer_cool_date">
                <el-date-picker
                    v-model="priceSettingForm.summer_cool_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="MM-dd"
                    value-format="MM-dd">
                </el-date-picker>
            </el-form-item>
			<el-form-item  style="margin-bottom: 0;">
				<el-radio-group v-model="priceSettingForm.is_all_heating">
				    <el-radio :label="0" :disabled="!isEdit">自定义供热</el-radio>
				    <el-radio :label="1" :disabled="!isEdit">全年供热</el-radio>
					<el-radio :label="2" :disabled="!isEdit">全年不供热</el-radio>
				</el-radio-group>
			</el-form-item>
            <el-form-item v-if='priceSettingForm.is_all_heating === 0' label="供热" prop="winter_hot_date">
                <el-date-picker
                    v-model="priceSettingForm.winter_hot_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="MM-dd"
                    value-format="MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-top: 24px;">
                <el-button type="primary" size="medium" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
        
    </div>
</template>

<script>
// 获取节假日第三方接口 http://tool.bitefu.net/jiari/?d=2019

import TimeRange from "./TimeRange";

const weekend = [{label: "星期六", value: "Saturday"}, {label: "星期日", value: "Sunday"}]
export default {
    name: 'cmpprice',
    props: ["form"],
    data() {
        return {
            priceSettingForm: {
// 基本计费
                base_generic_setting: 0,   //  是否使用基本计费（0默认，1使用，2不使用）
    // 是基本计费
                base_generic_rate: 0,          //  单价

// 分时间段计费
                expense_type: 0,   //  是否使用分时段计费（0默认，1使用，2不使用）
    // 不分时段计费
                base_cool_price: 0,     //  冷量单价
                base_hot_price: 0,      //  热量单价
    // 分时段计费
        // 时段类型
                holiday_charged: 0,   //  是否使用节假日计费（0默认，1使用，2不使用）
                weekend_charged: 0,   //  是否使用周末计费（0默认，1使用，2不使用）
                working_charged: 0,   //  是否使用工作日计费（0默认，1使用，2不使用）
            //  节假日
                holidays: [],        
                holiday_cool_price: 0,  //  节假日冷量单价
                holiday_hot_price: 0,  //  节假日热量单价
                
            // 周末
                // 时段类型
                weekends: [],
                weekend_cool_price: 0,  //  周末冷量单价
                weekend_hot_price: 0,  //  周末热量单价
            // 工作日
                first_time_start: 0,  //  	第一时间段开始时间
                first_time_end: 0,  //  第一时间段结束时间
                first_cool_price: 0,  //  	第一时间段冷量单价
                first_hot_price: 0,  //  第一时间段热量单价

                second_time_start: 0,  //  第二时间段开始时间
                second_time_end: 0,  //  第二时间段结束时间
                second_cool_price: 0,  //  第二时间段冷量单价
                second_hot_price: 0,  //  第二时间段热量单价

                third_time_start: 0,  //  第三时间段开始时间
                third_time_end: 0,  //  第三时间段结束时间
                third_cool_price: 0,  //  第三时间段冷量单价
                third_hot_price: 0,  //  第三时间段热量单价

                // 计费条件
                winter_hot_date: [],
                summer_cool_date: [],
				
				//供冷供热
				is_all_refrigeration:0,
				is_all_heating:0,
            },
            // 表单规则
            priceSettingRules: {
                basePrice: {
                    required: true,
                    message: "请输入价格",
                    trigger: "blur"
                },
                baseCoolPrice: {
                    required: true,
                    message: "请输入价格",
                    trigger: "blur"
                },
                baseHotPrice: {
                    required: true,
                    message: "请输入价格",
                    trigger: "blur"
                },
                expenseType: {
                    required: true,
                    message: "请选择计费类型",
                    trigger: "change"
                },
                timeType: {
                    type: "array",
                    required: true,
                    message: "请选择时段类型",
                    trigger: "change"
                },
                summer_cool_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                winter_hot_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
            },
            
            weekend: weekend,
            // 工作日默认时间段
            firstTime: ['00:00', '08:00'],
            secondTime: ['08:00', '18:00'],
			
            thirdTime: ['18:00', '23:59'],
            isEdit: true
        };
    },
    components: {
        TimeRange
    },
    created() {
        if(this.form.oid){
            this.initData(this.form);
        }
    },
    watch: {
        form(val){
            this.initData(val);
        }
    },
    methods: {
        // 初始化数据
		async initData(data) {
			let hm01_rule = data.hm01_rule
			let rate_setting =data.hm01_rule

            try {
                // 是否使用基本计费，基本计费单价
				let base_generic_rule =rate_setting.base_generic_rule
                let base_generic_setting = base_generic_rule.base_generic_setting
                let base_generic_rate = base_generic_rule.base_generic_rate;

                // this.priceSettingForm.oid = oid;
                this.priceSettingForm.base_generic_setting = base_generic_setting;
                this.priceSettingForm.base_generic_rate = base_generic_rate;

                // 计费条件，
                let summer_cool_date = rate_setting.rate_condition.cooling_period;
                let winter_hot_date = rate_setting.rate_condition.heating_period;

                this.priceSettingForm.winter_hot_date = winter_hot_date
                this.priceSettingForm.summer_cool_date = summer_cool_date
				
				// 供冷供热类型
				let is_all_refrigeration = rate_setting.rate_condition.is_all_refrigeration;
				let is_all_heating = rate_setting.rate_condition.is_all_heating;
				
				this.priceSettingForm.is_all_refrigeration = is_all_refrigeration * 1 
				this.priceSettingForm.is_all_heating = is_all_heating * 1 

                // 是否分时段计费
                let expense_type = rate_setting.tou_basic ? 0 : 1;
                this.priceSettingForm.expense_type = expense_type;
                if(rate_setting.tou_basic) {
                    // 不分时段  tou_basic
                    let base_cool_price = rate_setting.tou_basic.base_heat_rate
                    let base_hot_price = rate_setting.tou_basic.base_refrigeration_rate

                    this.priceSettingForm.base_cool_price = base_cool_price;
                    this.priceSettingForm.base_hot_price = base_hot_price;
                }else{
                    // 分时段  tou_full

                    // 节假日
                    let tou_holidays = rate_setting.tou_full.tou_holidays
                    let holiday_charged = tou_holidays? 1 : 2;
                    
                    if(holiday_charged===1) {
                        let holiday_cool_price = tou_holidays.rate_solution.base_refrigeration_rate
                        let holiday_hot_price = tou_holidays.rate_solution.base_heat_rate

                        // let holidays = tou_holidays.holidays;
                        this.priceSettingForm.holiday_cool_price = holiday_cool_price;
                        this.priceSettingForm.holiday_hot_price = holiday_hot_price;
                        // this.priceSettingForm.holidays = holidays;
                    }
                    this.priceSettingForm.holiday_charged = holiday_charged

                    // 周末
                    let tou_weekends = rate_setting.tou_full.tou_weekends
                    let weekend_charged = tou_weekends ? 1 : 2;
                    
                    if(weekend_charged===1) {
                        let weekends_arr = tou_weekends.weekends;
                        let weekend_cool_price = tou_weekends.rate_solution.base_refrigeration_rate
                        let weekend_hot_price = tou_weekends.rate_solution.base_heat_rate

                        this.priceSettingForm.weekend_cool_price = weekend_cool_price;
                        this.priceSettingForm.weekend_hot_price = weekend_hot_price;
                        this.priceSettingForm.weekends = weekends_arr
                    }
                    this.priceSettingForm.weekend_charged =weekend_charged;

                    // 工作日
                    let tou_workdays = rate_setting.tou_full.tou_workdays
                    let working_charged = tou_workdays ? 1 : 2;
                    if(tou_workdays.period_1th) {
                        // 第一时段
                        let first_time_start = tou_workdays.period_1th.from
                        let first_time_end = tou_workdays.period_1th.to
                        let first_cool_price = tou_workdays.period_1th.rate_solution.base_refrigeration_rate
                        let base_heat_rate = tou_workdays.period_1th.rate_solution.base_heat_rate

                        this.priceSettingForm.first_time_start = first_time_start;
                        this.priceSettingForm.first_time_end = first_time_end;
                        this.priceSettingForm.first_cool_price = first_cool_price;
                        this.priceSettingForm.first_hot_price = base_heat_rate;

                        this.firstTime = [first_time_start, first_time_end]
                    }
                    if(tou_workdays.period_2th) {
                        // 第二时段
                        let second_time_start = tou_workdays.period_2th.from
                        let second_time_end = tou_workdays.period_2th.to
                        let second_cool_price = tou_workdays.period_2th.rate_solution.base_refrigeration_rate
                        let second_hot_price = tou_workdays.period_2th.rate_solution.base_heat_rate

                        this.priceSettingForm.second_time_start = second_time_start;
                        this.priceSettingForm.second_time_end = second_time_end;
                        this.priceSettingForm.second_cool_price = second_cool_price;
                        this.priceSettingForm.second_hot_price = second_hot_price;

                        this.secondTime = [second_time_start, second_time_end]
                    }
                    if(tou_workdays.period_3th) {
                        // 第三时段
                        let third_time_start = tou_workdays.period_3th.from
                        let third_time_end = tou_workdays.period_3th.to
                        let third_cool_price = tou_workdays.period_3th.rate_solution.base_refrigeration_rate
                        let third_hot_price = tou_workdays.period_3th.rate_solution.base_heat_rate

                        this.priceSettingForm.third_time_start = third_time_start;
                        this.priceSettingForm.third_time_end = third_time_end;
                        this.priceSettingForm.third_cool_price = third_cool_price;
                        this.priceSettingForm.third_hot_price = third_hot_price;

                        this.thirdTime = [third_time_start, third_time_end]
                    }
                    this.priceSettingForm.working_charged = working_charged;
					
                }
            } catch (error) {
                this.$message.error("价格设置解析有误")
            }
        },
        // 获取法定节假日
        getLegalHolidays(value) {
           
            let year = new Date().getFullYear();    // 获取当前年份
            
        },
        // 删除某一个法定节假日
        handleHolidaysDelete(tag) {
            this.priceSettingForm.holidays.splice(
                this.priceSettingForm.holidays.indexOf(tag),
                1
            );
        },
        // 工作日时间段设置
        handleTimeRange(obj) {
            const index = obj.index;
            switch (index) {
                //  第一时间段
                case 1:
                    this.priceSettingForm.first_time_start = obj.time[0];
                    this.priceSettingForm.first_time_end = obj.time[1];
                    this.priceSettingForm.first_cool_price = obj.coolPrice;
                    this.priceSettingForm.first_hot_price = obj.hotPrice;
                    break;
                //  第二时间段
                case 2:
                    this.priceSettingForm.second_time_start = obj.time[0];
                    this.priceSettingForm.second_time_end = obj.time[1];
                    this.priceSettingForm.second_cool_price = obj.coolPrice;
                    this.priceSettingForm.second_hot_price = obj.hotPrice;
                    break;
                //  第三时间段
                case 3:
                    this.priceSettingForm.third_time_start = obj.time[0];
                    this.priceSettingForm.third_time_end = obj.time[1];
                    this.priceSettingForm.third_cool_price = obj.coolPrice;
                    this.priceSettingForm.third_hot_price = obj.hotPrice;
                    break;
                default:
                    break;
            }
        },

        // 保存
        handleSave() {
            let params = this.fmtFormData();
            this.$emit('onSave', params)
        },
        fmtFormData() {
            let rate_setting = {};
            // 基本计费
            let oid = this.priceSettingForm.oid
            // if(this.priceSettingForm.base_generic_setting == 1) {
            //     rate_setting.base_generic_rate = this.priceSettingForm.base_price
            // }else{
            //     rate_setting.base_generic_rate = 0
            // }
            
            // 计费条件
			let base_generic_rate = this.priceSettingForm.base_generic_rate
			let base_generic_setting = this.priceSettingForm.base_generic_setting
			
			rate_setting.base_generic_rule = {
			    base_generic_rate: base_generic_rate,
			    base_generic_setting: base_generic_setting,
			}
			//供冷
			if(this.priceSettingForm.is_all_refrigeration == 0){
				if(this.priceSettingForm.summer_cool_date[0].indexOf('00:00:00')== -1){
					this.priceSettingForm.summer_cool_date[0] = this.priceSettingForm.summer_cool_date[0] +' 00:00:00'
					this.priceSettingForm.summer_cool_date[1] = this.priceSettingForm.summer_cool_date[1] +' 23:59:59'
				}
			}else{
				this.priceSettingForm.summer_cool_date[0] = '01-01 00:00:00'
				this.priceSettingForm.summer_cool_date[1] = '01-01 00:00:00'
			}
			//供热
			if(this.priceSettingForm.is_all_heating == 0){
				if(this.priceSettingForm.winter_hot_date[0].indexOf('00:00:00')== -1){
					this.priceSettingForm.winter_hot_date[0] = this.priceSettingForm.winter_hot_date[0] +' 00:00:00'
					this.priceSettingForm.winter_hot_date[1] = this.priceSettingForm.winter_hot_date[1] +' 23:59:59'
				}
			}else{
				this.priceSettingForm.winter_hot_date[0] = '01-01 00:00:00'
				this.priceSettingForm.winter_hot_date[1] = '01-01 00:00:00'
			}
			
            let cooling_period = this.priceSettingForm.summer_cool_date
            let heating_period = this.priceSettingForm.winter_hot_date;
			let is_all_refrigeration=this.priceSettingForm.is_all_refrigeration
			let is_all_heating=this.priceSettingForm.is_all_heating
            rate_setting.rate_condition = {}
			rate_setting.rate_condition = {
			    cooling_period: cooling_period,
			    heating_period: heating_period,
				is_all_heating:is_all_heating,
				is_all_refrigeration:is_all_refrigeration,
			}
            // rate_setting.rate_condition.by_period = {
            //     cooling_period: cooling_period,
            //     heating_period: heating_period,
            // }

            if(this.priceSettingForm.expense_type === 0){
                // 不分时段计费
                rate_setting.tou_basic = {}
                rate_setting.tou_basic.base_heat_rate = this.priceSettingForm.base_cool_price
                rate_setting.tou_basic.base_refrigeration_rate = this.priceSettingForm.base_hot_price
            }
            
            if(this.priceSettingForm.expense_type === 1){
                rate_setting.tou_full = {}
                // 节假日
                if(this.priceSettingForm.holiday_charged == 1) {
                    rate_setting.tou_full.tou_holidays = {}
                    // rate_setting.tou_full.tou_holidays.holidays = this.priceSettingForm.holidays;
                    rate_setting.tou_full.tou_holidays.rate_solution = {
                        base_heat_rate: this.priceSettingForm.holiday_hot_price,
                        base_refrigeration_rate: this.priceSettingForm.holiday_cool_price,
                    }
                }

                // 周末
                if(this.priceSettingForm.weekend_charged == 1) {
                    rate_setting.tou_full.tou_weekends = {}
                    // rate_setting.tou_full.tou_weekends.weekends = this.priceSettingForm.weekends;
                    rate_setting.tou_full.tou_weekends.rate_solution = {
                        base_heat_rate: this.priceSettingForm.weekend_hot_price,
                        base_refrigeration_rate: this.priceSettingForm.weekend_cool_price,
                    }
                }
                // 工作日
                if(this.priceSettingForm.working_charged == 1) {
                    rate_setting.tou_full.tou_workdays = {}
                    if(this.priceSettingForm.first_time_start) {
                        // 第一时段
                        rate_setting.tou_full.tou_workdays.period_1th = {
                            from: this.priceSettingForm.first_time_start,
                            to: this.priceSettingForm.first_time_end
                        }
                        rate_setting.tou_full.tou_workdays.period_1th.rate_solution = {
                            base_heat_rate: this.priceSettingForm.first_hot_price,
                            base_refrigeration_rate: this.priceSettingForm.first_cool_price,
                        }
                    }
                    if(this.priceSettingForm.second_time_start) {
                        // 第二时段
                        rate_setting.tou_full.tou_workdays.period_2th = {}
                        rate_setting.tou_full.tou_workdays.period_2th.from = this.priceSettingForm.second_time_start
                        rate_setting.tou_full.tou_workdays.period_2th.to = this.priceSettingForm.second_time_end
                        rate_setting.tou_full.tou_workdays.period_2th.rate_solution = {
                            base_heat_rate: this.priceSettingForm.second_hot_price,
                            base_refrigeration_rate: this.priceSettingForm.second_cool_price,
                        }
                    }
                    if(this.priceSettingForm.third_time_start) {
                        rate_setting.tou_full.tou_workdays.period_3th = {}
                        rate_setting.tou_full.tou_workdays.period_3th.from = this.priceSettingForm.third_time_start
                        rate_setting.tou_full.tou_workdays.period_3th.to = this.priceSettingForm.third_time_end
                        rate_setting.tou_full.tou_workdays.period_3th.rate_solution = {
                            base_heat_rate: this.priceSettingForm.third_hot_price,
                            base_refrigeration_rate: this.priceSettingForm.third_cool_price,
                        }
                    }
                }


            }
            
            return {
                // oid: oid,
                hm01_rule:rate_setting
            }
        }
    }
}

</script>
<style>
.price-container .el-tag {
    margin: 5px;
}
.holiday-list-box .el-date-editor.el-input,
.holiday-list-box .el-date-editor.el-input__inner {
    width: 34px;
}
.holiday-list-box .el-input--prefix .el-input__inner {
    padding-left: 0;
    visibility: hidden;
}
.holiday-list-box .el-input--suffix .el-input__inner {
    padding-right: 0;
}
</style>

<style scoped>

.title {
    padding: 4px;
    margin-bottom: 12px;
    font-size: 18px;
    border-bottom: 1px solid #dcdfe6;
}
.price-setting-box {
    width: 600px;
    margin: auto;
}
.holiday-list-box {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 8px 12px;
}
</style>